export default "__VITE_ASSET__beed7ba5__"